// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import { useTranslation } from 'react-i18next';

import ImgBackground from '../../assets/homepage-background.jpg';

export default function PageHome() {
    const { t } = useTranslation('home', { keyPrefix: 'home' });

    return (<>
        <div className="fullpage-background" style={{ backgroundImage: `url(${ImgBackground})` }}>
            <div className="horizontal-vertical-center home-claim rainbow">
                <div dangerouslySetInnerHTML={{ __html: t('homeclaim', { interpolation: { escapeValue: false } }) }} />
            </div>
        </div>
    </>
    );
}
